import React from "react";
import { AbsoluteFill } from "remotion";

interface WatermarkProps {
  width: number;
  height: number;
}

/**
 * Watermark component for free account videos.
 * Displays "made with reel.cat" in the bottom-right corner.
 *
 * @param width - Video composition width
 * @param height - Video composition height
 */
export const Watermark: React.FC<WatermarkProps> = ({ width, height }) => {
  // Calculate responsive font size: 2.5% of smaller dimension, clamped between 12-24px
  const smallerDimension = Math.min(width, height);
  const baseFontSize = smallerDimension * 0.025;
  const fontSize = Math.max(12, Math.min(24, baseFontSize));

  // Calculate margin based on font size
  const margin = fontSize * 0.8;

  const containerStyle: React.CSSProperties = {
    position: "absolute",
    bottom: margin,
    right: margin,
    zIndex: 9999,
    pointerEvents: "none",
  };

  const textStyle: React.CSSProperties = {
    fontFamily:
      '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    fontSize: `${fontSize}px`,
    fontWeight: 500,
    color: "rgba(180, 180, 180, 0.6)",
    textShadow: "0 0 4px rgba(0, 0, 0, 0.3)",
    letterSpacing: "0.02em",
    whiteSpace: "nowrap",
  };

  return (
    <AbsoluteFill style={{ pointerEvents: "none" }}>
      <div style={containerStyle}>
        <span style={textStyle}>made with reel.cat</span>
      </div>
    </AbsoluteFill>
  );
};
